import { useEffect, useState } from 'react';
import axiosInstance from '../../api/axiosInstance';

/**
 * The SOP content: steps, the flowchart source per language, the three spoken
 * walkthroughs and the interface wording.
 *
 * Fetched rather than bundled. The document was deliberately kept out of wwwroot
 * because it names staff and describes how money is collected, and a copy compiled
 * into the frontend would be readable by anybody who can load the site — so the
 * content stays behind [Authorize] + the SopAccess right, and this is the one place
 * that asks for it. Fetched once per visit to the page and held while it is open.
 */
export function useSopData() {
    const [data, setData] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        let gone = false;
        axiosInstance.get('/Sop/Data')
            .then(res => { if (!gone) setData(res.data || null); })
            .catch(err => {
                if (gone) return;
                // 403 comes with the reason, so the person is told which of the two things
                // is missing rather than a flat "no".
                const reason = err?.response?.data?.reason;
                setError(
                    err?.response?.status === 403
                        ? reason === 'no-sale'
                            ? 'The SOP opens once you have your first sale — it walks through what happens after a sale is created.'
                            : 'You do not have access to the SOP. Ask an admin for the SOP right.'
                        : err?.response?.status === 404
                            ? 'The SOP has not been published yet.'
                            : 'Could not load the SOP. Please make sure you are logged in.',
                );
            });
        return () => { gone = true; };
    }, []);

    return { data, error, loading: !data && !error };
}
